<template>
  <div
    class="p-form-consent"
    :class="{
      'p-form-consent--side_menu': sideMenu
    }"
  >
    <p class="p-form-consent__heading">個人情報同意確認</p>
    <p></p>
    <p class="p-form-consent__lead">
      個人情報の利用に関して下記リンクの利用規約をご参照のうえ、ご同意いただける場合は「利用規約に同意する」ボタンをクリックしてください。利用規約は必ずお読みいただけるようにお願い申し上げます。
    </p>

    <div class="p-form-consent__button__wrap">
      <a
        href="https://bs.benefit-one.co.jp/BE-ONE/official/handling.html"
        target="_blank"
        @click="link_clicked"
        class="p-form-consent__button"
        >利用規約</a
      >
    </div>

    <slot></slot>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
	props: {
		sideMenu: { type: Boolean, required: false, default: false }
	}
})
export default class FormConsent extends Vue {
  sideMenu!: boolean;

  link_clicked() {
    this.$emit("link-clicked");
  }
}
</script>

<style lang="scss" scoped>
.p-form-consent {
  padding: rem(16);

  // TODO: irregular
  background-color: #f2f2f2;

  &__heading {
    font-size: rem(20);
    font-weight: bold;
    line-height: (27/20);
  }
  &__lead {
    // TODO: irregular
    color: #828282;
    font-size: rem(14);
    line-height: (24.5/14);
    margin-top: rem(12);
  }
  &__button {
    // TODO: irregular
    color: #4f4f4f;
    font-size: rem(16);
    font-weight: bold;
    line-height: (24/16);
    text-align: center;
    width: rem(288);
    max-width: 100%;
    padding: rem(14) rem(16) rem(15) rem(16);
    background-color: $common-white;
    // TODO: irregular
    border: px(1) solid #bdbdbd;
    border-radius: px(4);
    display: block;

    &--disabled {
      color: $common-gray300;
      border-color: $common-gray300;
    }
    &:focus {
      color: $common-gray900;
      border-color: $common-gray900;
    }

    &__wrap {
      margin-top: rem(16);
      display: flex;
      justify-content: center;

      @include sp {
        margin-top: rem(8);
      }
    }
  }

  &--side_menu &__heading {
    font-size: rem(16);
    line-height: (24/16);
  }
  &--side_menu &__lead {
    font-size: rem(10);
    line-height: (16/10);
  }
  &--side_menu &__button {
    padding: rem(11) rem(16) rem(12) rem(16);
  }
}
</style>
